import {GROUP_TYPE, CURSOR, getTextColor, GROUP_SECTION_WIDTH, drawRectangle, drawExpansionIcon, getTrimmedText, drawBorderLines /*, createCacheCanvas*/} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';
import {PROJECT_STATUS} from '../../../../constants';
import {cacheManager} from '../../canvas-timeline/canvas_timeline_cache_manager';
import {interactionManager} from '../../canvas-timeline/canvas_timeline_interaction_manager';
import Util from '../../../../forecast-app/shared/util/util';

class ProjectGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.PROJECT_SCHEDULING_PROJECT, data);
	}

	refreshData(updatedProject) {
		this.data.name = updatedProject.name;
		this.data.color = updatedProject.projectColor;
		this.data.clientName = updatedProject.client ? updatedProject.client.name : null;
		this.data.status = updatedProject.status;
	}

	draw(canvasContext, x, y) {
		const width = GROUP_SECTION_WIDTH;
		const {data, height, expanded, groupType, totalHeight} = this;
		super.draw(x, y, width, height, this);
		const {clientName, name, id, color, companyProjectId} = data;
		const cacheId = `${groupType}-${id}-${!!expanded}`;

		interactionManager.addCursorStyleArea(x, y, width, height, CURSOR.POINTER, true);

		const drawEncompassingBorder = () => {
			if (!expanded) return;
			const xOffset = data.isInProjectGroup ? 8 : 2;
			drawRectangle(canvasContext, xOffset, y + height - 1, width - xOffset - 1, totalHeight - height, {
				backgroundColor: color,
				borderBottomLeftRadius: 10,
			});
		};

		const cachedData = cacheManager.get(groupType, cacheId);
		if (cachedData) {
			canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
			drawEncompassingBorder();
			return;
		}

		const planning = [PROJECT_STATUS.PLANNING, PROJECT_STATUS.OPPORTUNITY].includes(data.status);
		const textColor = planning ? '#2a2a2a' : getTextColor(color);

		/*const drawGroup = () => {
			const cacheCanvas = createCacheCanvas(width, this.itemRowHeight);
			const context = cacheCanvas.getContext('2d');
			if (data.isInProjectGroup) {
				context.fillStyle = data.projectGroupColor;
				context.fillRect(8, 0, width, height);
				context.zIndex = -1;
			}
			//Subtract 1 from width and height to make room for the grey border
			drawRectangle(context, data.isInProjectGroup ? 8 : 2, 0, width - 3 - (data.isInProjectGroup ? 6 : 0), height - 1, {
				backgroundColor: planning ? '#ffffff' : color,
				borderColor: color,
				borderThickness: planning ? 2 : 0,
				borderTopLeftRadius: 10,
				borderBottomLeftRadius: expanded ? 0 : 10
			});
			drawExpansionIcon(context, 0, 0, width, height, {
				backgroundColor: planning ? undefined : color,
				expanded
			});
			if (!data.isInProjectGroup) {
				drawBorderLines(context, 0, 0, width, height, false);
			} else if (expanded) {
				drawBorderLines(context, 8, 0, width, height, false);
			} else {
				drawBorderLines(context, 8, 0, width, height, false, data.projectGroupColor);
			}

			context.fillStyle = textColor;
			//Drawing project id
			context.font = '700 10px ' + Util.getFontFamily();
			context.fillText(`P${companyProjectId}`, 16, clientName ? 17 : 24);

			//Drawing project and client (if present) name
			context.font = '500 12px ' + Util.getFontFamily();
			const formattedProjectName = getTrimmedText(context, name);
			if (clientName) {
				context.fillText(formattedProjectName, 52, 18);
				context.font = '400 11px ' + Util.getFontFamily();
				const formattedClientName = getTrimmedText(context, clientName);
				context.fillText(formattedClientName, 52, 33);
			} else {
				context.fillText(formattedProjectName, 52, 25);
			}
			cacheManager.set(groupType, cacheId, cacheCanvas);
			canvasContext.drawImage(cacheCanvas, x, y, width, this.itemRowHeight);
		};*/
		const drawGroup = () => {
			if (data.isInProjectGroup) {
				canvasContext.fillStyle = data.projectGroupColor;
				canvasContext.fillRect(x + 8, y + 0, width, height);
				canvasContext.zIndex = -1;
			}
			//Subtract 1 from width and height to make room for the grey border
			drawRectangle(canvasContext, x + (data.isInProjectGroup ? 8 : 2), y, width - 3 - (data.isInProjectGroup ? 6 : 0), height - 1, {
				backgroundColor: planning ? '#ffffff' : color,
				borderColor: color,
				borderThickness: planning ? 2 : 0,
				borderTopLeftRadius: 10,
				borderBottomLeftRadius: expanded ? 0 : 10,
			});
			drawExpansionIcon(canvasContext, x, y, width, height, {
				backgroundColor: planning ? undefined : color,
				expanded,
			});
			if (!data.isInProjectGroup) {
				drawBorderLines(canvasContext, x, y, width, height, false);
			} else if (expanded) {
				drawBorderLines(canvasContext, x + 8, y, width, height, false);
			} else {
				drawBorderLines(canvasContext, x + 8, y, width, height, false, data.projectGroupColor);
			}

			canvasContext.fillStyle = textColor;
			//Drawing project id
			canvasContext.font = '700 10px ' + Util.getFontFamily();
			canvasContext.fillText(`P${companyProjectId}`, x + 16, y + (clientName ? 17 : 24));

			//Drawing project and client (if present) name
			canvasContext.font = '500 12px ' + Util.getFontFamily();
			const formattedProjectName = getTrimmedText(canvasContext, name);
			if (clientName) {
				canvasContext.fillText(formattedProjectName, x + 52, y + 18);
				canvasContext.font = '400 11px ' + Util.getFontFamily();
				const formattedClientName = getTrimmedText(canvasContext, clientName);
				canvasContext.fillText(formattedClientName, x + 52, y + 33);
			} else {
				canvasContext.fillText(formattedProjectName, x + 52, y + 25);
			}
		};
		drawGroup();
		drawEncompassingBorder();
	}
}

export default ProjectGroup;
